<h2 class="text-tertiary d-flex justify-content-between uppercase">
  <span mat-dialog-title [attr.aria-label]="multilingualService.langMap?.LABEL_PMART_FORM_TITLE">{{
    multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_TITLE }}</span>
  <button class="close" (click)="close('cancel')" mat-icon-button
    [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG">
    <mat-icon class="icon-cross"></mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography">
  <div class="enrollment-form-content">
    <h3>
      {{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_TITLE }}
    </h3>
    <p>{{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_NOTE }}</p>
    <hr />
    <form [formGroup]="profileFormGroup">
      <!-- Contact Information -->
      <h3>
        {{
        multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_CONTACT_INFO
        }}
      </h3>
      <div class="d-flex full-width contact-details">
        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_FIRST_NAME
            }}</label>
          <p>{{ memberInfo.firstName }}</p>
        </div>
        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_LAST_NAME
            }}</label>
          <p>{{ memberInfo.lastName }}</p>
        </div>
      </div>
      <div class="d-flex full-width contact-details">
        <div class="w-50">
          <label for="date-of-birth">{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_DOB
            }}</label>
          <p>{{ memberInfo.dateOfBirth | date : "MM-dd-yyyy" }}</p>
        </div>
        <div class="w-50">
          <label for="gender-value">{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_GENDER
            }}</label>
          <p>{{ memberInfo.gender ? memberInfo.gender : '-' }}</p>
        </div>
      </div>
      <div class="d-flex full-width contact-details">
        <div class="w-50">
          <div class="form-group mr-3">
            <label>{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_HOME_PHONE
              }}</label>
            <input id="home-phone-input" appPhoneNumberFormat formControlName="homePhoneNumber"
              placeholder="(000) 000 0000" type="text" class="form-control" />

            <span role="alert" *ngIf="
                (profileFormGroup.get('homePhoneNumber')?.errors?.minlength ||
                profileFormGroup.get('homePhoneNumber')?.errors?.maxlength) &&
                profileFormGroup.get('homePhoneNumber')?.touched
              " class="text-danger">{{
              multilingualService.langMap
              ?.LABEL_FAMILY_PROFILE_PMART_PROFILE_MOBILE_NUMBER_VALIDATION_DIGITS
              }}</span>
          </div>
        </div>

        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_CONTACT_NUMBER
            }}</label>
          <p *ngIf="memberInfo.cellPhone">
            {{ memberInfo.cellPhone | phoneNumber }}
          </p>
          <p *ngIf="!memberInfo.cellPhone">-</p>
        </div>
      </div>
      <div class="d-flex full-width contact-details">

        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_EMAIL
            }}</label>
          <p>{{ memberInfo.email ? memberInfo.email : '-' }}</p>
        </div>
        <div class="w-50 d-flex" *ngIf="!isMinorDependent(memberInfo)">
          <div class="form-group full-width mr-3">
            <label>{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_NOTIFICATION_TEXT
              }}</label>
            <mat-checkbox class="mr-4 text-notification" formControlName="textNotification">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_NOTIFICATION_OPTION_TEXT
              }}</mat-checkbox>
            <mat-checkbox class="text-notification" formControlName="emailNotification">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_NOTIFICATION_OPTION_EMAIL
              }}</mat-checkbox>
          </div>
        </div>
      </div>
      <hr style="margin: 25px 0 20px" />
      <!-- Address -->
      <h3>
        {{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ADDRESS }}
      </h3>

      <ng-container *ngIf="this.shippingAddressesResponse$ | async as shippingAddresses; else loadShippingAddress">

        <ng-container *ngIf="shippingAddresses.length === 0">
          <ng-container *ngTemplateOutlet="addNewAddress"></ng-container>
        </ng-container>

        <!-- Import Angular Material's tab group -->
        <mat-tab-group *ngIf="shippingAddresses.length > 0" (selectedTabChange)="onTabChange($event)">
          <!-- First tab -->
          <mat-tab>
            <ng-template mat-tab-label>
              <label id="label-addnew" for="addnew">{{
                multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ADD_NEW
                }}</label>
            </ng-template>
            <ng-container *ngTemplateOutlet="addNewAddress"></ng-container>
          </mat-tab>

          <!-- Second tab -->
          <mat-tab *ngIf="shippingAddresses.length">
            <ng-template mat-tab-label>
              <label id="label-addfrom" for="addfrom">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_ADD_FROM_SHIPPING_ADDRESS
                }}</label>
            </ng-template>
            <div class="mt-2 d-flex full-width contact-details shipping-address">
              <div class="full-address d-flex" *ngFor="let address of shippingAddresses; let i = index">
                <div class="form-group full-width mr-3">
                  <mat-radio-group formControlName="selectedAddressIndex" name="addressGroup">
                    <mat-radio-button [value]="i">Address {{ getAddressIndex(i) }}</mat-radio-button>
                    <p class="address">
                      {{ address.addressLine1 }}, {{ address.addressLine2 }} <br />
                      {{ address.city }}, {{ address.state }},<br />
                      {{ address.zipCode }}
                    </p>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

        <ng-template #addNewAddress>
          <!-- Content for address -->
          <div class="mt-2 d-flex full-width contact-details">
            <div class="w-50 d-flex">
              <div class="form-group full-width mr-3">
                <label class="required">{{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_STREET_1
                  }}<span>*</span></label>
                <input id="street-address-input" formControlName="addressLine1" maxlength="55" type="text"
                  class="form-control" />
                <span role="alert" *ngIf="
                  profileFormGroup.get('addressLine1')?.errors?.required &&
                  profileFormGroup.get('addressLine1')?.touched
                "
                  class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
              </div>
            </div>
            <div class="w-50 d-flex">
              <div class="form-group full-width">
                <label>{{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_STREET_2 }}</label>
                <input id="street-address-input-2" formControlName="addressLine2" maxlength="55" type="text"
                  class="form-control" />
              </div>
            </div>
          </div>

          <div class="d-flex full-width contact-details">
            <div class="w-50 d-flex">
              <div class="form-group full-width mr-3">
                <label class="required">{{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_CITY
                  }}<span>*</span></label>
                <input id="city-input" formControlName="city" maxlength="35" type="text" class="form-control" />
                <span role="alert" *ngIf="
                profileFormGroup.get('city')?.errors?.required &&
                profileFormGroup.get('city')?.touched
              " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
              </div>
            </div>
            <div class="w-50 d-flex">
              <div class="form-group full-width">
                <label class="required">{{ multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_STATE
                  }}<span>*</span></label>
                <div class="select-box">
                  <select id="state-input" formControlName="state" class="form-control">
                    <option *ngFor="let state of states" [value]="state.value">
                      {{ state.name }}
                    </option>
                  </select>
                </div>
                <span role="alert" *ngIf="
                profileFormGroup.get('state')?.errors?.required &&
                profileFormGroup.get('state')?.touched
              " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
              </div>
            </div>
          </div>
          <div class="d-flex full-width contact-details">
            <div class="w-50 d-flex">
              <div class="form-group full-width mr-3">
                <label
                  class="required">{{multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ZIP_CODE}}<span>*</span></label>
                <input id="postal-input" formControlName="zipCode" maxlength="5" (keydown)="numericOnly($event)"
                  type="text" class="form-control" />
                <span role="alert" *ngIf="
                profileFormGroup.get('zipCode')?.errors?.required &&
                profileFormGroup.get('zipCode')?.touched
              " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                <span role="alert" *ngIf="
              (profileFormGroup.get('zipCode')?.errors?.minlength ||
              profileFormGroup.get('zipCode')?.errors?.maxlength) &&
              profileFormGroup.get('zipCode')?.touched
            " class="text-danger">{{
                  multilingualService.langMap
                  ?.LABEL_FAMILY_PROFILE_PMART_PROFILE_ZIP_CODE_LENGTH_VALIDATION
                  }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #loadShippingAddress>
        <div aria-busy="true" role="status" class="center loader-circle mb-3">
          <img src="assets/images/loader.gif" alt="loader" width="60px" />
        </div>
      </ng-template>

      <!-- Primary Language -->
      <hr style="margin: 0 0 20px" />
      <h3>
        {{
        multilingualService.langMap
        ?.LABEL_PMART_ENROLLMENT_FORM_PRIMARY_LANGUAGE
        }}<span>*</span>
      </h3>
      <div class="d-flex full-width contact-details">
        <div class="w-50 d-flex">
          <mat-radio-group formControlName="primaryLanguage">
            <mat-radio-button class="mr-4" value="English">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ENGLISH
              }}</mat-radio-button>
            <mat-radio-button class="mr-4" value="Spanish">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_SPANISH
              }}</mat-radio-button>
            <mat-radio-button value="other">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_OTHER
              }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="w-50" *ngIf="profileFormGroup?.value?.primaryLanguage === 'other'" style="margin-top: -30px;">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_OTHER
            }}</label>
          <input id="other-input" formControlName="otherLanguage" type="text" class="form-control" />
        </div>
      </div>

      <!-- Medical Information -->
      <hr style="margin: 25px 0 20px" />
      <h3>
        {{
        multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_MEDICAL_INFO
        }}
      </h3>
      <div class="d-flex full-width contact-details">
        <div class="form-group full-width w-50">
          <label class="required">{{
            multilingualService.langMap
            ?.LABEL_PMART_ENROLLMENT_FORM_DRUG_ALLERGIES
            }}<span>*</span></label>
          <mat-radio-group formControlName="hasDrugAllergies">
            <mat-radio-button class="mr-4" value="0">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_NO
              }}</mat-radio-button>
            <mat-radio-button value="1">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_YES
              }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="form-group full-width w-50 allergies">
          <div formArrayName="allergies" *ngIf="profileFormGroup.value.hasDrugAllergies === '1'">
            <label>{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ALLERGIES
              }}</label>
            <div class="allergies-checkbox" *ngFor="let a of allergiesList; let i = index">
              <mat-checkbox [formControlName]="i">{{ a }}</mat-checkbox>
            </div>
          </div>
          <div *ngIf="isOtherAllergySelected">
            <div id="addmore" class="d-flex full-width contact-details">
              <div class="form-group full-width" formGroupName="otherAllergies">
                <div formArrayName="otherA">
                  <div *ngFor="
                  let all of otherAllergiesArray.controls;
                  let i = index
                " [formGroupName]="i">
                    <div class="d-flex mb-1">
                      <input type="text" formControlName="allergy" maxlength="200" id="home-phone-input"
                        class="form-control" />
                      <button class="close" (click)="removeOtherAllergy(i)" mat-icon-button>
                        <mat-icon class="icon-delete"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <button class="add-more-button" (click)="addOneMoreAllergy()">
                  {{
                  multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ADD_MORE
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex full-width contact-details">
        <div class="form-group full-width w-50">
          <label class="required">{{
            multilingualService.langMap
            ?.LABEL_PMART_ENROLLMENT_FORM_MEDICAL_CONDITIONS
            }}<span>*</span></label>
          <mat-radio-group formControlName="hasMedicalConditions">
            <mat-radio-button value="0" class="mr-4">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_NO
              }}</mat-radio-button>
            <mat-radio-button value="1">{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_YES
              }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="profileFormGroup.value.hasMedicalConditions === '1'">
          <div id="addmore" class="d-flex full-width  w-50">
            <div class="form-group full-width" formGroupName="listOfMedicalConditions">
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_LIST_MEDICAL_CONDITIONS
                }}<span>*</span></label>
              <div formArrayName="list">
                <div *ngFor="
                  let condition of medicalConditionArray.controls;
                  let i = index
                " [formGroupName]="i">
                  <div class="d-flex mb-1">
                    <input type="text" formControlName="condition" maxlength="200" id="home-phone-input"
                      class="form-control" />
                    <button class="close" (click)="removeMedicalCondition(i)" mat-icon-button>
                      <mat-icon class="icon-delete"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <button class="add-more-button" (click)="addOneMoreMedicalCondition()">
                {{
                multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ADD_MORE
                }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
      <!--ADD MORE-->
      <div id="addmore" class="d-flex full-width contact-details">
        <div class="form-group full-width w-50" formGroupName="otherMedications">
          <p>
            {{
            multilingualService.langMap
            ?.LABEL_PMART_ENROLLMENT_FORM_OTHER_MEDICATIONS
            }}
          </p>
          <!-- <div class="d-flex">
            <input type="text" id="home-phone-input" class="form-control" />
            <button class="close" mat-icon-button>
              <mat-icon class="icon-delete"></mat-icon>
            </button>
          </div> -->
          <div formArrayName="otherM">
            <div *ngFor="
                let medication of otherMedicationsArray.controls;
                let i = index
              " [formGroupName]="i">
              <div class="d-flex mb-1">
                <input type="text" formControlName="otherCondition" maxlength="200" id="home-phone-input"
                  class="form-control" />
                <button class="close" (click)="removeOtherMedication(i)" mat-icon-button>
                  <mat-icon class="icon-delete"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          <button class="add-more-button" (click)="addMoreOtherMedication()">
            {{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_ADD_MORE
            }}
          </button>
        </div>
      </div>
      <!-- End ADD MORE-->

      <div class="d-flex full-width contact-details">
        <div class="form-group full-width w-50">
          <label class="required">{{
            multilingualService.langMap
            ?.LABEL_PMART_ENROLLMENT_FORM_NEED_CONTROLLED_SUBSTANCES
            }}</label>
          <mat-radio-group formControlName="controlledSubstances">
            <mat-radio-button class="mr-4" value='false'>{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_NO
              }}</mat-radio-button>
            <mat-radio-button value='true'>{{
              multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_YES
              }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="w-50" *ngIf="profileFormGroup.value.controlledSubstances === 'true'">
          <label class="required">{{
            multilingualService.langMap
            ?.LABEL_PMART_ENROLLMENT_FORM_DRIVER_LICENSE
            }}<span>*</span></label>
          <input id="license-input" formControlName="driverLicenseNumber" maxlength="50" type="text"
            class="form-control" />
          <span role="alert" *ngIf="
          profileFormGroup.get('driverLicenseNumber')?.errors?.required &&
          profileFormGroup.get('driverLicenseNumber')?.touched
        " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
        </div>
      </div>
      <!-- Insurance Information -->
      <hr style="margin: 25px 0 20px" />
      <h3>
        {{
        multilingualService.langMap
        ?.LABEL_PMART_ENROLLMENT_FORM_INSURANCE_INFO
        }}
      </h3>
      <div class="d-flex full-width contact-details">
        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_MEMBER_ID
            }}</label>
          <p>{{ memberInfo.cardId }}</p>
        </div>
        <div class="w-50">
          <label>{{
            multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_GROUP_ID
            }}</label>
          <p>{{ memberInfo.clientId === externalClientIdsMapping?.CLIENT_ID?
            externalClientIdsMapping?.EXTERNAL_CLIENT_ID : memberInfo.clientId }}</p>
        </div>
      </div>
      <!--New Prescriptions or Transfer(s)-->
      <hr />
      <p> {{multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_PRESCRIPTION_NOTICE}}</p>
      <h3>
        {{
        multilingualService.langMap
        ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS
        }}
      </h3>
      <div class="d-flex full-width contact-details">
        <div class="w-50 d-flex">
          <div class="form-group full-width mr-3">
            <label class="required mb-3">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_TEXT2
              }}<span>*</span></label>

            <mat-radio-group formControlName="prescriptionsTransfer" class="new-prescriptions-options">
              <mat-radio-button class="full-width" value="doctorSendMedications">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_OPTION1
                }}</mat-radio-button>
              <mat-radio-button class="full-width" value="faxDoctorForMedications">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_OPTION2
                }}</mat-radio-button>
              <mat-radio-button class="full-width" value="transferFromPharmacy">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_OPTION3
                }}</mat-radio-button>
              <mat-radio-button class="full-width" value="other">{{
                multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_OTHER
                }}</mat-radio-button>
            </mat-radio-group>
            <p class="mt-2" *ngIf="
            profileFormGroup.value.prescriptionsTransfer ===
            'faxDoctorForMedications'
          ">
              <strong>{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_SUBTEXT_1
                }}:</strong>
              {{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_NEW_PRESCRIPTIONS_SUBTEXT_2
              }}
            </p>
          </div>
        </div>
        <div class="w-50">
          <ng-container *ngIf="
              profileFormGroup.value.prescriptionsTransfer ===
              'faxDoctorForMedications'
            ">
            <div class="form-group full-width" formGroupName="faxDetails">
              <div formArrayName="details">
                <div *ngFor="
                let detail of faxDetailsArray.controls;
                let i = index
              " [formGroupName]="i">
                  <hr style="margin: 20px 0;" *ngIf="i !== 0">
                  <div class="form-group full-width">
                    <label class="required">{{
                      multilingualService.langMap
                      ?.LABEL_PMART_ENROLLMENT_FORM_PRESCRIBER
                      }} <span>*</span></label>
                    <input id="prescriber-input" formControlName="prescriberName" maxlength="100" type="text"
                      class="form-control" />
                    <span role="alert" *ngIf="
                      detail.get('prescriberName')?.hasError('required') &&
                      detail.get('prescriberName')?.touched
                    "
                      class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                  </div>
                  <div class="form-group full-width">
                    <label class="required">{{
                      multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_PHONE
                      }} <span>*</span></label>
                    <input id="phone-input" appPhoneNumberFormat placeholder="(000) 000 0000"
                      formControlName="prescriberPhoneNumber" type="text" class="form-control" />
                    <span role="alert" *ngIf="
                      (detail.get('prescriberPhoneNumber')?.hasError('minlength') ||
                      detail.get('prescriberPhoneNumber')?.hasError('maxlength')) &&
                      detail.get('prescriberPhoneNumber')?.touched
                    " class="text-danger">{{
                      multilingualService.langMap
                      ?.LABEL_FAMILY_PROFILE_PMART_PROFILE_MOBILE_NUMBER_VALIDATION_DIGITS
                      }}</span>
                    <span role="alert" *ngIf="
                      detail.get('prescriberPhoneNumber')?.hasError('required') &&
                      detail.get('prescriberPhoneNumber')?.touched
                    "
                      class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                  </div>
                  <div class="form-group full-width">
                    <label class="required">{{
                      multilingualService.langMap?.LABEL_PMART_ENROLLMENT_FORM_FAX
                      }} <span>*</span></label>
                    <input id="fax-input" formControlName="prescriberFaxNumber" maxlength="55" type="text"
                      class="form-control" />
                    <span role="alert" *ngIf="
                      detail.get('prescriberFaxNumber')?.hasError('required') &&
                      detail.get('prescriberFaxNumber')?.touched
                    "
                      class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                  </div>
                  <div class="form-group full-width">
                    <label class="required">{{
                      multilingualService.langMap
                      ?.LABEL_PMART_ENROLLMENT_FORM_PRESCRIPTION_NAME
                      }} <span>*</span></label>
                    <input id="prescription-name-input" formControlName="prescriptionName" maxlength="55" type="text"
                      class="form-control" />
                    <span role="alert" *ngIf="
                      detail.get('prescriptionName')?.hasError('required') &&
                      detail.get('prescriptionName')?.touched
                    "
                      class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                  </div>
                  <div class="form-group full-width">
                    <label class="required">{{
                      multilingualService.langMap
                      ?.LABEL_PMART_ENROLLMENT_FORM_PRESCRIPTION_STRENGTH
                      }} <span>*</span></label>
                    <input id="prescriber-strength-input" formControlName="prescriptionStrength" maxlength="55"
                      type="text" class="form-control" />
                    <span role="alert" *ngIf="
                      detail.get('prescriptionStrength')?.hasError('required') &&
                      detail.get('prescriptionStrength')?.touched
                    "
                      class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
                  </div>
                  <button class="add-more-button mr-3" *ngIf="i === faxDetailsArray.controls.length -1"
                    (click)="addMoreOtherFlexDetails()">
                    {{
                    multilingualService.langMap
                    ?.LABEL_PMART_ENROLLMENT_FORM_ADD_MORE
                    }}
                  </button>
                  <button class="add-more-button" *ngIf="i !== 0" (click)="removeFaxDetails(i)">
                    {{
                    multilingualService.langMap
                    ?.LABEL_COMMON_DELETE
                    }}
                  </button>

                </div>
              </div>
            </div>

          </ng-container>

          <div class="form-group full-width new-prescription-details" *ngIf="
              profileFormGroup.value.prescriptionsTransfer ===
              'doctorSendMedications'
            ">
            <p>
              <strong>{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_1
                }} </strong><br />{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_2
              }}
            </p>
            <p>
              <strong>{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_3
                }} </strong><br />{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_4
              }}<br />{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_5
              }}
            </p>
            <p class="mb-1">
              {{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_6
              }}<br />{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_DOC_PRESCRIPTIONS_TEXT_7
              }}
            </p>
          </div>

          <ng-container *ngIf="
              profileFormGroup.value.prescriptionsTransfer ===
              'transferFromPharmacy'
            ">
            <div class="form-group full-width">
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_CURRENT_PHARMACY
                }}<span>*</span></label>
              <input id="current-pharmacy-input" formControlName="currentPharmacy" maxlength="100" type="text"
                class="form-control" />
              <span role="alert" *ngIf="
              profileFormGroup.get('currentPharmacy')?.errors?.required &&
              profileFormGroup.get('currentPharmacy')?.touched
            " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>

            </div>
            <div class="form-group full-width">
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_PHARMACY_PHONE
                }}<span>*</span></label>
              <input id="pharmacy-phone-input" appPhoneNumberFormat formControlName="pharmacyPhoneNumber" maxlength="55"
                type="text" class="form-control" />
              <span role="alert" *ngIf="
                (profileFormGroup.get('pharmacyPhoneNumber')?.errors?.minlength ||
                profileFormGroup.get('pharmacyPhoneNumber')?.errors?.maxlength) &&
                profileFormGroup.get('pharmacyPhoneNumber')?.touched
              " class="text-danger">{{
                multilingualService.langMap
                ?.LABEL_FAMILY_PROFILE_PMART_PROFILE_MOBILE_NUMBER_VALIDATION_DIGITS
                }}</span>
              <span role="alert" *ngIf="
                profileFormGroup.get('pharmacyPhoneNumber')?.errors?.required &&
                profileFormGroup.get('pharmacyPhoneNumber')?.touched
              "
                class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
            </div>

            <div class="form-group full-width" formGroupName="prescriptions">
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_PRESCRIPTIONS
                }}<span>*</span></label>
              <div formArrayName="prescriptionDetails">
                <div *ngFor="
                    let pres of prescriptionsArray.controls;
                    let i = index
                  " [formGroupName]="i">
                  <div class="d-flex mb-1">
                    <input id="pharmacy-phone-input" maxlength="50" formControlName="prescriptionDetail" type="text"
                      class="form-control" />
                    <button class="close" (click)="removePrescription(i)" mat-icon-button>
                      <mat-icon class="icon-delete"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <span role="alert" *ngIf="
              profileFormGroup.get('prescriptions')?.status === 'INVALID' &&
              profileFormGroup.get('prescriptions')?.touched
            " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>
              <button class="add-more-button" (click)="addOneMorePrescription()">
                {{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_ADD_MORE
                }}
              </button>
            </div>

          </ng-container>

          <div *ngIf="profileFormGroup.value.prescriptionsTransfer === 'other'" class="form-group full-width">
            <label class="required">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_OTHER
              }}<span>*</span></label>
            <textarea id="other-textarea" maxlength="1000" formControlName="otherPrescriptionInstructions" type="text"
              class="form-control comments"></textarea>
          </div>
        </div>
      </div>
      <hr style="margin: 15px 0 20px" />
      <div class="d-flex full-width contact-details">
        <div class="w-50 d-flex">
          <div class="form-group full-width mr-3">
            <label class="required">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_ADDITIONAL_COMMENTS
              }}</label>
            <textarea id="comments-textarea" maxlength="1000" formControlName="additionalComments" type="text"
              class="form-control comments"></textarea>
          </div>
        </div>
        <div class="w-50 d-flex">
          <div class="form-group full-width">
            <div class="d-flex full-width justify-content-between">
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_SIGNATURE
                }}<span>*</span></label>
              <label class="required">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_SIGNATURE_SUFFIX
                }}</label>
            </div>
            <input (change)="signatureChange()" id="signature-input" formControlName="signature" type="text"
              class="form-control" />
            <span role="alert" *ngIf="
            profileFormGroup.get('signature')?.errors?.required &&
            profileFormGroup.get('signature')?.touched
          " class="text-danger">{{multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_REQUIRED_MESSAGE}}</span>

            <span role="alert" *ngIf="!isSignatureMatch"
              class="text-danger">{{multilingualService.langMap?.LABEL_SIGNATURE_NOTE}}</span>

          </div>
        </div>
      </div>
      <div class="d-flex full-width contact-details" *ngIf="acknowledgmentLinks$ | async as links">
        <div class="w-50">
          <mat-checkbox class="policies-rights" formControlName="acknowledgePharmacyPrivacyPolicies">
            <span class="text">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_PRIVACY_POLICY_1
              }}&nbsp;<a (click)="privacyPolicyClicked()" [href]="links.privacyPolicy" target="_blank">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_PRIVACY_POLICY_2
                }}</a><span>*</span></span></mat-checkbox>
        </div>
        <div class="w-50">
          <mat-checkbox class="policies-rights" formControlName="haveViewedPatientBillOfRights">
            <span class="text">{{
              multilingualService.langMap
              ?.LABEL_PMART_ENROLLMENT_FORM_BILL_RIGHTS_1
              }}
              <a (click)="patientBillOfRightsClicked()" [href]="links.patientBillRights" target="_blank">{{
                multilingualService.langMap
                ?.LABEL_PMART_ENROLLMENT_FORM_BILL_RIGHTS_2
                }}</a><span>*</span></span></mat-checkbox>
        </div>
      </div>
      <div class="text-center">
        <button mat-raised-button class="primary-button uppercase" (click)="createMailOrderProfile()"
          [disabled]="profileFormGroup.invalid || !isSignatureMatch">
          {{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_SUBMIT }}
        </button>
      </div>
    </form>
  </div>
</mat-dialog-content>
<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
<ng-template #success>
  <div class="toaster-bg success d-flex justify-content-center">
    <mat-icon class="icon-success mr-1"></mat-icon>
    <span>{{ multilingualService.langMap?.LABEL_UPDATE_PROFILE_SUCCESS }}</span>
  </div>
</ng-template>
<div class="loader-container" *ngIf="isLoading$|async">
  <div aria-busy="true" role="status" class="center loader-circle">
    <img src="assets/images/loader.gif" alt="loader" width="60px" />
  </div>
</div>
<!-- <mat-dialog-actions> </mat-dialog-actions> -->